<template>
    <div class="content d-flex flex-column flex-column-fluid mb-10" id="kt_content">

        <div class="toolbar" id="kt_toolbar">
          <app-sub-header :title="title" :breadcrumbs="breadcrumbs" :back="false"></app-sub-header>
        </div>

    <!-- Modal PDF facture -->
    <div class="modal fade" tabindex="-1" id="orderPdfModal">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header py-3">
            <h5 class="modal-title">{{ $t('shop.invoice') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" @click="closePdfModal"></button>
          </div>
          <div class="modal-body p-0" style="height:80vh">
            <div v-if="pdfLoading" class="d-flex align-items-center justify-content-center h-100">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
            <iframe v-else-if="orderPdfUrl" :src="orderPdfUrl" class="w-100 h-100 border-0"></iframe>
          </div>
          <div class="modal-footer py-2">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal" @click="closePdfModal">{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>

        <div class="post d-flex flex-column-fluid" id="kt_post">
            <div id="kt_content_container" class="container-xxl" style="margin-bottom: 50px!important;">
              <div class="card">
                <div class="card card-custom" >
                  <div class="card-header flex-wrap border-0 pt-6 pb-0">
                    <div class="card-title">
                      <h3 class="card-label">{{ $t('e-commerce.commandeList') }}</h3>
                    </div>
                    <div class="card-toolbar d-flex align-items-center gap-3">
                      <!-- Filtre par statut -->
                      <Select2
                        v-model="query.status"
                        :isRequired="false"
                        :multiple="false"
                        :show-search="false"
                        :placeholderText="$t('e-commerce.checkout.all_status')"
                        :selectClass="'form-select form-select-solid kt_select2 w-200px'"
                        containerClass="d-flex flex-column fv-row me-2"
                        name="commande_status"
                      >
                        <option value="all">{{ $t('e-commerce.checkout.all_status') }}</option>
                        <option
                          v-for="(status, index) in checkoutStatus"
                          :key="index"
                          :value="status.value">
                          {{ status[locale] }}
                        </option>
                      </Select2>
                      <!-- Sélecteur de dates -->
                      <div dashboard-kt-daterangepicker="true" data-kt-daterangepicker-opens="left"
                           class="btn btn-light d-flex align-items-center px-4 date-range-btn">
                        <i class="bi bi-calendar3 me-2 text-primary"></i>
                        <span class="fw-semibold text-gray-700">{{ $t('dashboard.loading') }}...</span>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <table class="table align-middle table-row-bordered fs-6 gy-3 orders-table" id="kt_datatable_customer_purchase" style="margin-top: 13px !important; cursor:pointer">
                      <thead>
                        <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                          <th> {{$t("e-commerce.date")}}</th>
                          <th> {{$t("e-commerce.number")}}</th>
                          <th> {{$t("e-commerce.customer")}}</th>
                          <th> {{$t("e-commerce.amount_ttc")}}</th>
                          <th> {{$t("e-commerce.status")}}</th>
                          <th> {{$t("e-commerce.payment_method")}}</th>
                          <th> {{$t("e-commerce.payment_status")}}</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { BASE_URL } from "@/services/api";
import AppSubHeader from "@/views/E-commerce/Partials/AppSubHeader.vue";
import { formattedLocalAmount } from "@/mixins/Helper.vue";
import { nextTick } from "vue";
import Select2 from "@/components/Select2.vue";

export default {
  components: { AppSubHeader, Select2 },

  data() {
    return {
      title: 'navigation.e-commerce',
      breadcrumbs: [
        { name: 'breadcrumbs.store.dashboard', path: '/admin/dashboard' },
        { name: 'e-commerce.commandeList', path: '/admin/ecommerce/orders' },
      ],
      table: null,
      query: {
        startDate: '',
        endDate: '',
        status: 'all'
      },
      orderPdfUrl: null,
      pdfLoading: false
    }
  },

  computed: {
    ...mapGetters('core', ['getCheckoutStatus']),
    ...mapGetters('payments', ['getPaymentEnums', 'getPaymentStatusEnums']),

    locale() {
      return this.$i18n?.locale;
    },
    checkoutStatus() {
      return this.getCheckoutStatus || [];
    },
    getDatatableLocaleUrl() {
      return this.locale === 'fr'
        ? "//cdn.datatables.net/plug-ins/1.10.20/i18n/French.json"
        : "//cdn.datatables.net/plug-ins/1.10.20/i18n/English.json";
    }
  },

  watch: {
    'query.status': function() {
      this.reloadTable();
    },
    'query.startDate': function() {
      this.reloadTable();
    },
    '$i18n.locale': function() {
      nextTick(() => {
        this.initDateRange();
        this.fetchPurchases();
      });
    }
  },

  async mounted() {
    await Promise.all([
      this.$store.dispatch('core/loadCheckoutStatus'),
      this.$store.dispatch('payments/loadPaymentEnums'),
      this.$store.dispatch('payments/loadPaymentStatusEnums')
    ]);

    this.initDateRange();
    this.fetchPurchases();
    this.initSelect2();

    // les colonnes masquées en CSS sur mobile doivent être remesurées quand on change de palier
    this.mobileQuery = window.matchMedia('(max-width: 575.98px)');
    this.onMobileChange = () => this.table?.columns.adjust().responsive.recalc();
    this.mobileQuery.addEventListener('change', this.onMobileChange);

    $(document).on("click", "#kt_datatable_customer_purchase .edit_btn", (e) => {
      let id = e.target.getAttribute('data-id');
      this.$router.push({ name: 'ecommerce-destockage-path', params: { id: id } });
    });

    $(document).on("click", "#kt_datatable_customer_purchase .pdf_btn", async (e) => {
      const checkoutId = e.target.getAttribute('data-id') || e.target.closest('[data-id]')?.getAttribute('data-id');
      if (!checkoutId) return;

      const isPWA    = window.matchMedia('(display-mode: standalone)').matches;
      const isMobile = window.innerWidth <= 767;

      if (isPWA || isMobile) {
        try {
          const response = await axios({
            url: BASE_URL + '/get/pdf/checkout/' + checkoutId,
            method: 'GET',
            responseType: 'blob',
            headers: { Authorization: 'Bearer ' + Ls.get('auth.token') }
          });
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const url  = window.URL.createObjectURL(blob);
          const a    = document.createElement('a');
          a.href     = url;
          a.download = `facture-${checkoutId}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => window.URL.revokeObjectURL(url), 1500);
        } catch {
          window.toastr['error'](i18n.global.t('error'));
        }
        return;
      }

      this.orderPdfUrl = null;
      this.pdfLoading = true;
      $('#orderPdfModal').modal('show');
      try {
        const response = await axios({
          url: BASE_URL + '/get/pdf/checkout/' + checkoutId,
          method: 'GET',
          responseType: 'blob',
          headers: { Authorization: 'Bearer ' + Ls.get('auth.token') }
        });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        this.orderPdfUrl = window.URL.createObjectURL(blob);
      } catch {
        $('#orderPdfModal').modal('hide');
        window.toastr['error'](i18n.global.t('error'));
      } finally {
        this.pdfLoading = false;
      }
    });
  },

  beforeUnmount() {
    this.mobileQuery?.removeEventListener('change', this.onMobileChange);
  },

  methods: {
    initSelect2() {
      KTApp.initSelect2()
      $('.kt_select2').select2()
      $('.kt_select2').off('change.commandes').on('change.commandes', (e) => {
        if (e.target.name === 'commande_status') {
          this.query.status = e.target.value
        }
      })
    },

    reloadTable() {
      if (this.table) {
        const status = this.query.status === 'all' ? '' : this.query.status;
        const url = BASE_URL + `/get/ecommerce/orders/datatable?startDate=${this.query.startDate}&endDate=${this.query.endDate}&status=${status}`;
        this.table.ajax.url(url).load();
      }
    },

    initDateRange() {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]');
      let start = moment().subtract(29, 'days');
      let end = moment();

      this.query.startDate = start.format('DD-MM-YYYY');
      this.query.endDate = end.format('DD-MM-YYYY');

      $(element).daterangepicker({
        direction: KTUtil.isRTL(),
        startDate: start,
        endDate: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: i18n.global.t('apply'),
          cancelLabel: i18n.global.t('cancel'),
          fromLabel: i18n.global.t('from'),
          toLabel: i18n.global.t('to'),
          customRangeLabel: i18n.global.t('custom_range'),
          weekLabel: 'S',
          daysOfWeek: [i18n.global.t('di'), i18n.global.t('lu'), i18n.global.t('ma'), i18n.global.t('me'), i18n.global.t('je'), i18n.global.t('ve'), i18n.global.t('sa')],
          monthNames: [i18n.global.t('january'), i18n.global.t('february'), i18n.global.t('march'), i18n.global.t('april'), i18n.global.t('may'), i18n.global.t('june'), i18n.global.t('july'), i18n.global.t('august'), i18n.global.t('september'), i18n.global.t('october'), i18n.global.t('november'), i18n.global.t('december')],
          firstDay: 1
        },
        ranges: {
          [i18n.global.t('today')]: [moment(), moment()],
          [i18n.global.t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [i18n.global.t('last7Days')]: [moment().subtract(6, 'days'), moment()],
          [i18n.global.t('last30Days')]: [moment().subtract(29, 'days'), moment()],
          [i18n.global.t('thisMonth')]: [moment().startOf('month'), moment().endOf('month')],
          [i18n.global.t('lastMonth')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
      }, this.cb);

      this.cb(start, end);
    },

    cb(start, end) {
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]');
      let display = element.querySelector('span');
      if (display) {
        display.innerHTML = start.format('D MMM YYYY') + ' - ' + end.format('D MMM YYYY');
      }
      this.query.startDate = start.format('DD-MM-YYYY');
      this.query.endDate = end.format('DD-MM-YYYY');
    },

    escapeHtml(value) {
      return $('<div>').text(value ?? '').html()
    },

    // précision du client : icône, texte complet au survol
    noteBadge(e, extraClass = '') {
      if (!e.customer_note) return ''
      // texte du client dans un attribut : guillemets échappés aussi (escapeHtml ne le fait pas)
      const title = this.escapeHtml(e.customer_note).replace(/"/g, '&quot;').replace(/'/g, '&#39;')
      return '<span class="badge badge-light-warning fs-8 px-2 py-2' + extraClass + '" title="' + title + '">💬</span>'
    },
    // acompte payé à la commande, tant que la commande n'est pas soldée
    depositBadge(e, extraClass = '') {
      const deposit = Number(e.deposit_amount) || 0
      if (deposit <= 0 || e.payment_status === 'PAID') return ''
      const amount = formattedLocalAmount(deposit) + ' ' + (e.currency_symbol || '')
      return '<span class="badge badge-light-info fw-semibold fs-8 px-3 py-2' + extraClass + '">' + this.escapeHtml(i18n.global.t('deposit.badge', { amount })) + '</span>'
    },
    // heure de retrait choisie par le client
    // « Retrait aujourd'hui à 12:30 », « Retrait demain à 12:30 », sinon « Retrait le ven. 03/10 à 12:30 »
    pickupBadge(e) {
      let label = ''
      if (e.pickup_at) {
        const d = new Date(e.pickup_at)
        const time = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
        const dayDiff = Math.round((new Date(d.getFullYear(), d.getMonth(), d.getDate()) - new Date(new Date().setHours(0, 0, 0, 0))) / 86400000)
        if (dayDiff === 0) label = i18n.global.t('destockage.pickup_today', { time })
        else if (dayDiff === 1) label = i18n.global.t('destockage.pickup_tomorrow', { time })
        else label = i18n.global.t('destockage.pickup_at', { date: d.toLocaleDateString('fr-FR', { weekday: 'short', day: '2-digit', month: '2-digit' }) + ' à ' + time })
      } else if (e.pickup_asap) {
        label = i18n.global.t('destockage.pickup_asap')
      }
      if (!label) return ''
      return '<span class="badge fs-9" style="background:#e8f1fd;color:#1e6fd9"><i class="fas fa-clock fs-9 me-1"></i>' + label + '</span>'
    },

    closePdfModal() {
      if (this.orderPdfUrl) {
        window.URL.revokeObjectURL(this.orderPdfUrl);
        this.orderPdfUrl = null;
      }
    },

    fetchPurchases() {
      const AUTH_TOKEN = Ls.get('auth.token');
      const status = this.query.status === 'all' ? '' : this.query.status;
      const url = `/get/ecommerce/orders/datatable?startDate=${this.query.startDate}&endDate=${this.query.endDate}&status=${status}`;

      this.table = $("#kt_datatable_customer_purchase").DataTable({
        destroy: true,
        responsive: true,
        searchDelay: 500,
        processing: true,
        serverSide: true,
        pageLength: Ls.get('pageLength') ?? 10,
        lengthMenu: [5, 10, 25, 50, 75, 100],
        order: [[0, 'desc']],
        ajax: {
          url: BASE_URL + url,
          type: "GET",
          beforeSend: function(request) {
            request.setRequestHeader("Authorization", "Bearer " + AUTH_TOKEN);
          }
        },
        columns: [
          { data: "date" },
          { data: "number" },
          { data: "customer" },
          { data: "total" },
          { data: "status" },
          { data: "payment_method" },
          { data: "payment_status" },
          { data: "Actions", responsivePriority: -1 }
        ],
        columnDefs: [
          {
            targets: 0,
            className: "dt-center text-center",
            render: (t, a, e, l) => {
              // sur mobile, cette cellule résume toute la commande (les autres colonnes sont masquées en CSS)
              const badge = (color, label) => '<span class="badge badge-light-' + color + ' fw-semibold fs-9">' + label + '</span>'
              const summary = '<div class="order-cell-mobile text-start">'
                + '<div class="d-flex justify-content-between align-items-baseline gap-2">'
                + '<span class="fw-bolder text-gray-800">' + e.number + '</span>'
                + '<span class="fw-bolder text-gray-800 text-nowrap">' + formattedLocalAmount(e.total) + ' ' + (e.currency_symbol || '') + '</span>'
                + '</div>'
                + '<div class="text-muted fs-7">' + [this.escapeHtml(e.customer), t].filter(Boolean).join(' · ') + '</div>'
                + '<div class="d-flex flex-wrap gap-1 mt-1">'
                + badge(e.status_color || 'secondary', e.status_label || e.status || '-')
                + badge(e.payment_status_color || 'secondary', e.payment_status_label || e.payment_status || '-')
                + this.depositBadge(e)
                + this.noteBadge(e)
                + badge(e.payment_method_color || 'primary', e.payment_method_label || e.payment_method || '-')
                + this.pickupBadge(e)
                + '</div>'
                + '</div>'
              return '<span class="order-cell-desktop">' + t + '</span>' + summary;
            }
          },
          {
            targets: 1,
            className: "dt-center text-center order-col-extra",
            render: (t, a, e, l) => {
              const pickup = this.pickupBadge(e)
              return '<span>' + t + '</span>' + (pickup ? '<div class="mt-1">' + pickup + '</div>' : '');
            }
          },
          {
            targets: 2,
            className: "dt-center text-center order-col-extra",
            render: (t, a, e, l) => {
              return '<span>' + t + '</span>';
            }
          },
          {
            targets: 3,
            className: "dt-center text-center order-col-extra",
            render: (t, a, e, l) => {
              return '<span>' + formattedLocalAmount(t) + ' ' + (e.currency_symbol || '') + '</span>';
            }
          },
          {
            targets: 4,
            className: "dt-center text-center order-col-extra",
            orderable: false,
            searchable: false,
            render: (t, a, e, l) => {
              const color = e.status_color || 'secondary';
              const label = e.status_label || e.status || '-';
              return '<span class="badge badge-light-' + color + ' fw-semibold fs-8 px-3 py-2">' + label + '</span>';
            }
          },
          {
            targets: 5,
            className: "dt-center text-center order-col-extra",
            orderable: false,
            searchable: false,
            render: (t, a, e, l) => {
              const color = e.payment_method_color || 'primary';
              const label = e.payment_method_label || e.payment_method || '-';
              return '<span class="badge badge-light-' + color + ' fw-semibold fs-8 px-3 py-2">' + label + '</span>';
            }
          },
          {
            targets: 6,
            className: "dt-center text-center order-col-extra",
            orderable: false,
            searchable: false,
            render: (t, a, e, l) => {
              const color = e.payment_status_color || 'secondary';
              const label = e.payment_status_label || e.payment_status || '-';
              return '<span class="badge badge-light-' + color + ' fw-semibold fs-8 px-3 py-2">' + label + '</span>' + this.depositBadge(e, ' ms-1') + this.noteBadge(e, ' ms-1');
            }
          },
          {
            targets: 7,
            className: "dt-center",
            title: "Actions",
            orderable: false,
            render: (t, a, e, l) => {
              let render = "";
              render += '<a href="javascript:;" data-id="' + e.id + '" class="btn btn-sm btn-clean btn-icon pdf_btn" title="' + i18n.global.t('shop.invoice') + '"><i data-id="' + e.id + '" class="bi bi-file-earmark-pdf fs-2 text-danger"></i></a>';
              if (this.$can('order_update')) {
                render += '<a href="javascript:;" data-id="' + e.id + '" class="btn btn-sm btn-clean btn-icon edit_btn" title="' + i18n.global.t('button.edit') + '"><i data-id="' + e.id + '" class="la la-eye fs-2"></i></a>';
              }
              return render;
            }
          }
        ],
        language: {
          url: this.getDatatableLocaleUrl
        }
      });
    }
  }
}
</script>

<style scoped>
.date-range-btn {
  height: 42px;
  border-radius: 8px;
  border: 1px solid #e4e6ef;
  background-color: #f5f8fa;
  color: #5e6278;
  transition: all 0.2s ease;
}

.date-range-btn:hover {
  background-color: #3699FF;
  border-color: #3699FF;
  color: #fff !important;
}

.date-range-btn:hover i,
.date-range-btn:hover span {
  color: #fff !important;
}
</style>

<style>
/* Liste des commandes : sur mobile, une cellule résumé + les actions */
.orders-table .order-cell-mobile {
  display: none;
}

@media (max-width: 575.98px) {
  .orders-table thead,
  .orders-table .order-col-extra,
  .orders-table .order-cell-desktop {
    display: none !important;
  }

  .orders-table .order-cell-mobile {
    display: block;
  }
}
</style>
